import common from './common.json';
import messages from './messages.json';

export const ru = {
  common,
  messages,
};
